define('models/graph/graph',[
    'underscore', 'backbone', 'moment', 'utils',
    // services
    'services/api'
], function(_, Backbone, moment, U, API) {

    var MGraph = Backbone.Model.extend({
        idAttribute: '_id',
        urlRoot: function() {
            var url = "graphs/" + this.type +
                "/" + this.frequency +
                "/" + this.startDate +
                "/" + this.endDate;

            if (this.user) {
                url = 'users/' + this.user + '/' + url;
            }

            return API.url(url);
        },

        parse: function(data, options) {
            if (this.isWeekly()) data = this.parseWeekData(data);
            if (this.isActivityData()) data = this.addZeroData(data);
            if (this.isDuration()) data = this.convertDurationData(data);

            return MGraph.__super__.parse.apply(this, [data, options]);
        },

        parseWeekData: function(data) {
            var newDataObject = {};

            _.each(data, function(val, key) {
                var year = key.split(':')[0],
                    week = key.split(':')[1],
                    firstDayOfWeek = moment().year(year).isoWeek(week).startOf('isoWeek').format('YYYY-MM-DD');

                newDataObject[firstDayOfWeek] = val;
            });

            return newDataObject;
        },

        addZeroData: function(data) {
            var newDataObject = {},
                startDate = this.getMinDateByFrequency(this.startDate),
                endDate = this.getMaxDateByFrequency(this.endDate);

            for (startDate; startDate.isBefore(endDate); startDate.add(1, this.getStepSize())) {
                var formattedDate = this.getMinDateByFrequency(startDate).format('YYYY-MM-DD'),
                    hasData = _.has(data, formattedDate);
                if (!hasData) {
                    newDataObject[formattedDate] = 0;
                } else {
                    newDataObject[formattedDate] = data[formattedDate];
                }
            }

            return newDataObject;
        },

        convertDurationData: function(data) {
            return _.mapObject(data, function(val, key) {
                return val / 60; // convert seconds to minutes
            });
        },

        getStepSize: function() {
            var frequency = this.frequency,
                stepSize;

            if (frequency === 'weekly') {
                stepSize = 'weeks';
            } else if (frequency === 'daily') {
                stepSize = 'days';
            } else {
                stepSize = 'months';
            }

            return stepSize;
        },

        hasWeekData: function(data, formattedDate) {
            return _.findKey(data, function(val, key) {
                return moment(formattedDate).startOf('isoWeek').isSame(moment().isoWeek(key.split(':')[1]).startOf('isoWeek'));
            });
        },

        getMinDateByFrequency: function(date) {
            var momentDate = moment(date),
                frequency = this.frequency;

            if (frequency === 'weekly') {
                date = momentDate.startOf('isoWeek');
            } else if (frequency === 'daily') {
                date = momentDate.subtract(1, 'day');
            } else {
                date = momentDate.startOf('month');
            }

            return date;
        },

        getMaxDateByFrequency: function(date) {
            var momentDate = moment(date),
                frequency = this.frequency;

            if (frequency === 'weekly') {
                date = momentDate.endOf('isoWeek');
            } else if (frequency === 'daily') {
                date = momentDate.add(1, 'day');
            } else {
                date = momentDate.endOf('month');
            }

            return date;
        },

        setFrequency: function(frequency) {
            this.frequency = frequency;
        },

        setType: function(type) {
            this.type = type;
        },

        setStartDate: function(startDate) {
            this.startDate = API.formatDate(startDate);
        },

        setEndDate: function(endDate) {
            this.endDate = API.formatDate(endDate);
        },

        setRequest: function(configObj) {
            _.each(configObj, function(val, key) {
                this[key] = val;
            }, this);
        },

        isCustomSeries: function(series) {
            return this.getDefaultSeries().where({ value: series }).length === 0;
        },

        isWeekly: function() {
            return this.frequency === 'weekly';
        },

        isDuration: function() {
            return this.type === 'duration';
        },

        // data generated by activity entries
        isActivityData: function() {
            var type = this.type;
            return type === 'distance' || type === 'duration' || type === 'calories';
        },

        getDefaultSeries: function() {
            return new Backbone.Collection([
                { label: 'Distance', value: 'distance' },
                { label: 'Burnt Calories', value: 'calories' },
                { label: 'Feedback Level', value: 'feedback_level' },
                { label: 'Duration', value: 'duration' }
            ]);
        },

        getFrequencies: function() {
            return [
                { label: 'graph:Monthly', value: 'monthly' },
                { label: 'graph:Weekly', value: 'weekly' },
                { label: 'graph:Daily', value: 'daily' },
            ];
        },

        getDefaultConfig: function() {
            return new Backbone.Model({
                type: 'distance',
                frequency: 'daily',
                done: true
            });
        },

        fetch: function(opt) {
            opt = opt || {};
            if (opt.user) this.user = opt.user;
            return MGraph.__super__.fetch.call(this, opt);
        },

    });

    // Return the model for the module
    return MGraph;
});

